// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1xyJI","disabled":"FileBtn_disabled__2CNeN","warn":"FileBtn_warn__2UGn2","fade":"FileBtn_fade__2s3Mq"};